export { default } from './HowTo.vue';